// extracted by mini-css-extract-plugin
module.exports = {"title":"itensContent_title__0e6Q_","containerItens":"itensContent_containerItens__DA_HR","addMoreItems":"itensContent_addMoreItems__9nxEN"};